import styled from 'styled-components';
import { theme } from "../../theme";
export var DialogFooter = styled.div.withConfig({
  displayName: "DialogFooter",
  componentId: "vapor__sc-1pyavtp-0"
})(["display:flex;padding:", ";border-top:", ";"], theme.spaces[16], function (p) {
  return p.showTopBorder ? "1px solid ".concat(theme.colors.border.primary) : 'none';
});
DialogFooter.defaultProps = {
  showTopBorder: true
};